import ChartDataLabels from 'chartjs-plugin-datalabels'

import { BarChart } from '@/components/charts/bar-chart.tsx'
import { Card } from '@/components/ui/card.tsx'
import { CHART_COLORS } from '@/modules/tracking/new-subscriber-analysis/consts/color.ts'
import type { SubscribersAnalysisDataUI } from '@/modules/tracking/new-subscriber-analysis/types.ts'
import { useIsDarkTheme } from '@/utils/useTheme.tsx'

interface Props {
  subscribersAnalysis: SubscribersAnalysisDataUI | null
  isFetching: boolean
}
export const InteractionOverview = ({
  subscribersAnalysis,
  isFetching,
}: Props) => {
  const isAllDataEmpty =
    !subscribersAnalysis?.interactionOverviewData?.ignored &&
    !subscribersAnalysis?.interactionOverviewData?.seen &&
    !subscribersAnalysis?.interactionOverviewData?.replied
  const isDarkMode = useIsDarkTheme()

  if (isFetching) {
    return <div className="h-72  animate-pulse rounded-md bg-skeleton" />
  }

  return (
    <Card className="flex flex-col justify-between p-6">
      <div className="text-xl font-semibold leading-none">
        Interaction Overview
      </div>

      <BarChart
        toggleOptions={{
          hideLabels: true,
        }}
        plugins={[ChartDataLabels]}
        options={{
          layout: {
            padding: {
              top: 30,
            },
          },
          scales: {
            y: {
              grid: {
                display: false,
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              yAlign: 'bottom',
            },
            datalabels: {
              anchor: 'end',
              align: 'end',
              font: {
                size: 14,
                family: 'Inter',
                weight: 500,
              },
              labels: {
                value: {
                  color: isDarkMode ? CHART_COLORS.WHITE : CHART_COLORS.BLACK,
                },
              },
            },
          },
        }}
        data={
          isAllDataEmpty
            ? { labels: [], datasets: [] }
            : {
                labels: ['Unanswered', 'Read', 'Replied'],
                datasets: [
                  {
                    data: [
                      subscribersAnalysis?.interactionOverviewData?.ignored ||
                        0,
                      subscribersAnalysis?.interactionOverviewData?.seen || 0,
                      subscribersAnalysis?.interactionOverviewData?.replied ||
                        0,
                    ],
                    borderRadius: 4,
                    backgroundColor: [
                      CHART_COLORS.PINK,
                      CHART_COLORS.YELLOW,
                      CHART_COLORS.BLUE,
                    ],
                  },
                ],
              }
        }
      />
    </Card>
  )
}
